import styled from '@emotion/styled/macro';

const TITLE_HEIGHT = '20px';
const FOOTER_HEIGHT = '20px';
const ICON_HEIGHT = TITLE_HEIGHT;

export const TransactionItem = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 4px;
  border-radius: 4px;

  &:hover {
    background-color: var(--background-neutral-hovered);
  }
`;

export const Title = styled.div`
  display: flex;
  height: ${TITLE_HEIGHT};
  line-height: ${TITLE_HEIGHT};
  width: 100%;
  > div:not(:first-of-type) {
    margin-left: 5px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px 0 5px;
  overflow: hidden;
  flex: 1;
`;

export const Footer = styled.div`
  height: ${FOOTER_HEIGHT};
  line-height: ${FOOTER_HEIGHT};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: var(--text);
  font-size: 12px;
  margin-top: 5px;
`;

export const FooterInfo = styled.div`
  :first-of-type {
    flex: 1;
    display: flex;

    > div {
      :not(:first-of-type):before {
        margin: 0 4px;
        content: '|';
      }
    }
  }
`;

export const UserName = styled.div`
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserAction = styled.div`
  display: flex;
  white-space: nowrap;
  margin-left: 5px;
  gap: 5px;
`;

export const ActionText = styled.div`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  max-width: 70%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TimerText = styled.div`
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
`;

export const ManagePanel = styled.div`
  display: flex;
  margin-left: auto !important;
  > button {
    > svg {
      height: ${ICON_HEIGHT};
      width: ${ICON_HEIGHT};
    }
  }
`;

export const CardInfo = styled.div`
  display: flex;
  flex: 1;
  min-width: 0; // it's workaround https://css-tricks.com/flexbox-truncated-text/
`;

export const CardName = styled.span`
  margin-left: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text);
  cursor: pointer;
  text-decoration: ${({ textDecoration }) => textDecoration};
`;

export const Comment = styled.div`
  flex-grow: 1;
  color: #6b778c;

  ${({ placement }) =>
    placement === 'body' &&
    `
      background-color: #fff;
      border-radius: 3px;
      box-shadow: 0 1px 2px -1px #091e4240, 0 0 0 1px #091e4214;
      display: inline-block;
      margin: 5px 0;
  `}

  ${({ placement }) =>
    placement === 'title' &&
    `
      margin-left: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      :before {
        content: ' - ';
      }
  `}
`;

export const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  align-self: center;
  background-color: ${({ timerStatus }) =>
    timerStatus === 'pause' ? 'orange' : 'green'};
`;

export const Divider = styled.hr`
  margin: 6px 0 0 0;
  background-color: var(--border);
`;

export const Timeline = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 12px;
  color: #6b778c;
`;

export const ExpandButton = styled('button')`
  padding: 0px 4px;
  border-radius: 3px;
  border: none;
  line-height: 16px;
  font-weight: bold;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.expand};
  background-color: ${({ theme }) => theme.bgColors.expand};
  &:hover {
    background-color: ${({ theme }) => theme.bgColors.expandHover};
  }
`;
